import { getTopDestination, GetTopDestinationParams, TopDestinationResponse } from "@/actions/destination.action";
import { useQuery } from "@tanstack/react-query";

export const useTopDestination = (params: GetTopDestinationParams) => {
  return useQuery<TopDestinationResponse, Error>({
    queryKey: ["top-destination", params.svcType, params.limit],
    queryFn: () => getTopDestination(params),
    staleTime: 24 * 60 * 60 * 1000, // 24h — data rarely changes, avoid refetch churn
    gcTime: 7 * 24 * 60 * 60 * 1000, // 7 days — keep cached entries around across sessions
  });
};